export default "__VITE_ASSET__CvlSpv9h__"